module.exports = __webpack_public_path__ + "img/46200.6da75ab7.jpg";